/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BooleanTestStepParameterDto } from './BooleanTestStepParameterDto';
import type { DateTestStepParameterDto } from './DateTestStepParameterDto';
import type { ExactValueTestStepParameterDto } from './ExactValueTestStepParameterDto';
import type { GreaterThanAndLessThanOrEqualsRangeTestStepParameterDto } from './GreaterThanAndLessThanOrEqualsRangeTestStepParameterDto';
import type { GreaterThanOrEqualAndLessThanRangeTestStepParameterDto } from './GreaterThanOrEqualAndLessThanRangeTestStepParameterDto';
import type { GreaterThanOrEqualValueTestStepParameterDto } from './GreaterThanOrEqualValueTestStepParameterDto';
import type { GreaterThanValueTestStepParameterDto } from './GreaterThanValueTestStepParameterDto';
import type { LessThanOrEqualValueTestStepParameterDto } from './LessThanOrEqualValueTestStepParameterDto';
import type { LessThanValueTestStepParameterDto } from './LessThanValueTestStepParameterDto';
import type { MinMaxRangeTestStepParameterDto } from './MinMaxRangeTestStepParameterDto';
import type { NumericTestStepConfigurationDto } from './NumericTestStepConfigurationDto';
import type { RateReportTestParameterDto } from './RateReportTestParameterDto';
import type { SelectionTestStepConfigurationDto } from './SelectionTestStepConfigurationDto';
import type { SelectionTestStepParameterDto } from './SelectionTestStepParameterDto';
import type { StringTestStepConfigurationDto } from './StringTestStepConfigurationDto';
import type { StringTestStepParameterDto } from './StringTestStepParameterDto';
export type TestStepDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    type: TestStepDto.type;
    name: string;
    subTitle?: string;
    configuration?: (NumericTestStepConfigurationDto | SelectionTestStepConfigurationDto | StringTestStepConfigurationDto);
    readonly parameters?: Array<(BooleanTestStepParameterDto | DateTestStepParameterDto | ExactValueTestStepParameterDto | GreaterThanAndLessThanOrEqualsRangeTestStepParameterDto | GreaterThanOrEqualAndLessThanRangeTestStepParameterDto | GreaterThanOrEqualValueTestStepParameterDto | GreaterThanValueTestStepParameterDto | LessThanOrEqualValueTestStepParameterDto | LessThanValueTestStepParameterDto | MinMaxRangeTestStepParameterDto | RateReportTestParameterDto | SelectionTestStepParameterDto | StringTestStepParameterDto)>;
    order?: number;
};
export namespace TestStepDto {
    export enum type {
        BOOLEAN = 'BOOLEAN',
        NUMERIC = 'NUMERIC',
        STRING = 'STRING',
        SELECTION = 'SELECTION',
        DATE = 'DATE',
    }
}

